module.exports = __webpack_public_path__ + "static/img/about_authority_05_zh.06553ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_authority_05_zh.png
// module id = 0VXz
// module chunks = 34